import { render } from "./Idle.vue?vue&type=template&id=79e64860&scoped=true"
import script from "./Idle.vue?vue&type=script&lang=js"
export * from "./Idle.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=79e64860&scoped=true&lang=css"
import "@/assets/css/user/pages/intro.css?vue&type=style&index=1&id=79e64860&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=2&id=79e64860&scoped=true&lang=css"
import "@/assets/css/user/dark/intro-dark.css?vue&type=style&index=3&id=79e64860&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e64860"]])

export default __exports__